import { render } from "./ModulosActivacion.vue?vue&type=template&id=1dbbd999"
import script from "./ModulosActivacion.vue?vue&type=script&lang=js"
export * from "./ModulosActivacion.vue?vue&type=script&lang=js"

import "./ModulosActivacion.vue?vue&type=style&index=0&id=1dbbd999&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__